import { type z } from 'zod'

import { schemas } from '~interface/zod-schema'

export type AssetType = z.infer<typeof schemas.AssetTypeEnum>
export const AssetTypeEnum = schemas.AssetTypeEnum
export type DownloadRequestStatus = 'idle' | 'pending' | 'success' | 'error' | 'warning'
